import { showToast } from '../stories/Components/Toaster/toast-helper';
import { drawerDialogService } from '../stories/Components/Dialog-Drawer/dialog-drawer.js';

/**
 * Handle API errors and show appropriate UI feedback
 * @param {Error} error - The error object from the API call
 * @param {string} defaultMessage - Default message to show if no specific error message
 */
export const handleApiError = (error, defaultMessage = 'An error occurred') => {
  // Extract error message
  let errorMessage = error.message || defaultMessage;
  
  // Show error message in toaster
  showToast({
    message: errorMessage,
    type: 'error',
    duration: 5000,
    position: 'top-right'
  });

  // Handle specific status codes
  if (error.status === 418) {
    // Show wallet popup for 418 status
    drawerDialogService.openDialog('wallet-popup', {
      onConfirm: () => {
        // Navigate to wallet page
        window.location.href = '/wallet';
      },
      onCancel: () => {
        // Close the popup
        drawerDialogService.closeDialog('wallet-popup');
      }
    });
  }
  
  // Log the error for debugging
  console.error('API Error:', {
    message: errorMessage,
    status: error.status,
    error: error
  });
};

/**
 * Handle successful API responses
 * @param {string} message - Success message to show
 */
export const handleApiSuccess = (message = 'Operation completed successfully') => {
  showToast({
    message: message,
    type: 'success',
    duration: 3000,
    position: 'top-right'
  });
}; 